import React from 'react'
import PositionHolder from './Position'
import { PositionsWrapper } from './PositionStyles'
import { HandlePositionsContent } from './helpers/positionsContent'
import { POSITION_HOLDER_PROPS } from './interface'

function Positions({ positionHolderVariables }: POSITION_HOLDER_PROPS) {
  const { anteStake, raiseStake, turnStake, riverStake, padding } =
    positionHolderVariables
  const content = HandlePositionsContent(
    anteStake,
    raiseStake,
    turnStake,
    riverStake,
  )

  return (
    <PositionsWrapper padding={padding}>
      {content.map((item, id) => (
        <PositionHolder
          key={id}
          title={item.title}
          content={item.content}
          icon={item.icon && item.icon}
          withBet={item.withBet}
        />
      ))}
    </PositionsWrapper>
  )
}

export default Positions
